import {Settings} from "./Settings";

let sanitizeHtml = require('sanitize-html');

class Helpers {

    trimAtNextWhitespace(inputString, maxLength) {
        if (inputString.length <= maxLength) {
            return inputString;
        }

        let nextWhitespace = inputString.indexOf(" ", maxLength);
        if (nextWhitespace === -1) {
            return inputString.substring(0, maxLength - 3) + "..."
        }
        return inputString.substring(0, nextWhitespace) + "..."
    }

    formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";

            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            let result = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
            return result;
        } catch (e) {
            console.log(e)
        }
    };

    safeHtml(input) {
        // Documentation: https://www.npmjs.com/package/sanitize-html
        let attributes = sanitizeHtml.defaults.allowedAttributes;
        attributes["font"] = ["color", "size" ];
        attributes["iframe"] = ["src", "style", "frameborder", "class", "allowfullscreen", "vr", "width", "height"];
        return sanitizeHtml(input, {
            allowedTags: sanitizeHtml.defaults.allowedTags.concat([ 'p', 'img', 'b', 'strong', 'i', 'font', 'iframe']),
            allowedAttributes: attributes
        }).replace(/(\r\n|\n|\r)/gm, "<br />");
    }

    getVideoEmbedUrl(url) {
        if (url.indexOf("youtu")>=0) {
            return this.getYoutubeEmbedFromUrl(url);
        }

        if (url.indexOf("vimeo") >= 0) {
            return this.getVimeoEmbedFromUrl(url);
        }

        if (url.indexOf("matterport") >= 0) {
            return this.getMatterportEmbedFromUrl(url);
        }
    }

    getYoutubeEmbedFromUrl(url) {
        if (!url) {
            return "";
        }

        let videoId = "";


        if (url.indexOf(".be/") >= 0)
        {
            // Url in the format of youtu.be/####
            videoId = url.substring(url.indexOf(".be/") + 4);
        }
        else if (url.indexOf("v=") >= 0)
        {
            // Url in the format of youtube.com/watch?v=####
            videoId = url.substring(url.indexOf("v=") + 2);
        }
        else if (url.indexOf("shorts/") >= 0)
        {
            // Url in the format of youtube.com/watch?v=####
            videoId = url.substring(url.indexOf("shorts/") + 7);
        }
        else
        {
            // Maybe the user just entered a video ID
            videoId = url;
        }

        return "https://www.youtube.com/embed/" + videoId;
    }

    getVimeoEmbedFromUrl(url) {
        if (!url) {
            return "";
        }

        let pattern = /.*\/([a-zA-Z0-9-_]+)/g;
        let match = pattern.exec(url);
        if (match) {
            return "https://player.vimeo.com/video/" + match[1];
        }
        return "";
    }

    getMatterportEmbedFromUrl(url) {
        if (!url) {
            return "";
        }

        let pattern = /https:\/\/my.matterport.com\/([^\""]*)/g;
        let match = pattern.exec(url);
        if (match) {
            return "https://my.matterport.com/" + match[1];
        }
        return "";
    }

    getMapsUrl(street, city, state, zip) {
        return "https://www.google.com/maps/embed/v1/search?key=AIzaSyA3UXOKLzfFQSJUO1sXNupEJZWV4_KkHH8&zoom=9&q=" + encodeURI(street) + ", " + encodeURI(city) + ", " + encodeURI(state) + " " + encodeURI(zip);
    }

    getBaseUrl(inventoryType) {
        switch (inventoryType) {
            case Settings.inventoryTypes.TRAILER:
                return Settings.trailersUrl;
            case Settings.inventoryTypes.CARGO:
                return Settings.cargoUrl;
            case Settings.inventoryTypes.TRUCK:
                return Settings.trucksUrl;
            case Settings.inventoryTypes.PART:
                return Settings.partsUrl;
            default:
                return "";
        }
    }

    compareObjects(o, p)
    {
        var i,
            keysO = Object.keys(o).sort(),
            keysP = Object.keys(p).sort();
        if (keysO.length !== keysP.length)
            return false;//not the same nr of keys
        if (keysO.join('') !== keysP.join(''))
            return false;//different keys
        for (i=0;i<keysO.length;++i)
        {
            if (o[keysO[i]] instanceof Array)
            {
                if (!(p[keysO[i]] instanceof Array))
                    return false;
                //if (compareObjects(o[keysO[i]], p[keysO[i]] === false) return false
                //would work, too, and perhaps is a better fit, still, this is easy, too
                if (p[keysO[i]].sort().join('') !== o[keysO[i]].sort().join(''))
                    return false;
            }
            else if (o[keysO[i]] instanceof Date)
            {
                if (!(p[keysO[i]] instanceof Date))
                    return false;
                if ((''+o[keysO[i]]) !== (''+p[keysO[i]]))
                    return false;
            }
            else if (o[keysO[i]] instanceof Function)
            {
                if (!(p[keysO[i]] instanceof Function))
                    return false;
                //ignore functions, or check them regardless?
            }
            else if (o[keysO[i]] instanceof Object)
            {
                if (!(p[keysO[i]] instanceof Object))
                    return false;
                if (o[keysO[i]] === o)
                {//self reference?
                    if (p[keysO[i]] !== p)
                        return false;
                }
                else if (this.compareObjects(o[keysO[i]], p[keysO[i]]) === false)
                    return false;//WARNING: does not deal with circular refs other than ^^
            }
            if (o[keysO[i]] !== p[keysO[i]])//change !== to != for loose comparison
                return false;//not the same value
        }
        return true;
    }

    getListingId(url, prefix) {
        let listingIdPart = url.substring(prefix.length);

        // Find the next trailing slash or end of string
        let nextPathCharacterPosition = listingIdPart.indexOf("/");
        if (nextPathCharacterPosition >= 0) {
            return listingIdPart.substring(0, nextPathCharacterPosition);
        }
        return listingIdPart;
    }

    getSeoFriendlyName(inputText) {
        inputText = inputText.replace(/[^a-zA-Z0-9]/g, '-'); // Replace non alphanumeric with dash
        inputText = inputText.replace(/-+/g, '-'); // Replace multiple dashes with one
        inputText = this.trimStart(inputText, '-'); // Remove any leading and trailing dashes
        inputText = this.trimEnd(inputText, '-');
        return inputText;
    }

    trimStart(string, charToRemove) {
        while(string.charAt(0)===charToRemove) {
            string = string.substring(1);
        }
        return string;
    }

    trimEnd(string, charToRemove) {
        while(string.charAt(string.length-1)===charToRemove) {
            string = string.substring(0,string.length-1);
        }
        return string;
    }
}

export default new Helpers()